export default "__VITE_ASSET__BfE8kP_v__"